import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormGeneralIcon.tsx
const MedFormGeneralIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "general-icon.svg",
		alt: t("medicationForm.form")
	});
};

//#endregion
export { MedFormGeneralIcon };